module.exports = __webpack_public_path__ + "static/media/hordeum_vulgare.flower_parts.81117fe1.svg";